import { useState, useCallback } from 'react';
import { MapPresenter } from '../MapPresenter';
import { AoiData } from '../Map.types';
import { MapWidgetPosition } from '../components/widgets/MapWidget.types';

export function useGfmWidget(presenter: MapPresenter) {
    const [position, setPosition] = useState<MapWidgetPosition>(MapWidgetPosition.HIDDEN);
    const [isDrawing, setGfmActiveDrawing] = useState<boolean>(false);

    const showAoi = useCallback((aoi: AoiData) => {
        console.debug("Showing GFM AOI", aoi);
        presenter.gfm.show(aoi);
    }, [presenter]);

    const hideAoi = useCallback((aoi: AoiData) => {
        console.debug("Hiding GFM AOI", aoi);
        presenter.gfm.hide(aoi);
    }, [presenter]);

    const startDrawAoi = useCallback(() => {
        console.debug("Drawing GFM AOI");
        setGfmActiveDrawing(true);
        presenter.gfm.addInteraction(() => setGfmActiveDrawing(false));
    }, [presenter]);

    const clearDrawAoi = useCallback(() => {
        console.debug("Clearing GFM AOI draw interaction");
        presenter.gfm.clearInteraction();
    }, [presenter]);

    const createAoi = useCallback((name: string, description: string, onResult: () => void) => {
        console.debug("Creating GFM AOI", name);
        presenter.gfm.createAoi(name, description, onResult);
    }, [presenter]);

    return {
        position: position,
        isDrawing: isDrawing,
        setPosition: setPosition,
        showAoi,
        hideAoi,
        startDrawAoi,
        clearDrawAoi,
        createAoi,
    };
}
